import { render, staticRenderFns } from "./TtoTable.vue?vue&type=template&id=6f36ff5b&scoped=true"
import script from "./TtoTable.vue?vue&type=script&lang=ts"
export * from "./TtoTable.vue?vue&type=script&lang=ts"
import style0 from "./TtoTable.vue?vue&type=style&index=0&id=6f36ff5b&prod&scoped=true&lang=less"
import style1 from "./TtoTable.vue?vue&type=style&index=1&id=6f36ff5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f36ff5b",
  null
  
)

export default component.exports